import React, { useEffect, useState } from 'react';
import { OfficeEntity } from '@features/desks/services/AdvanceHotDeskingService';
import { BodyRegular, BodySmall, BodyVerySmall } from '@shared/ui/atoms/fonts/Body';
import styled from "styled-components";
import { Row } from '@shared/ui/atoms/StructuralLayout';
import TextField, { TextFieldProps } from '@shared/ui/atoms/TextField';
import { getOfficeCapacity } from '@features/desks/services/OfficeCapacityService';
import moment from "moment";
import Colours from '@shared/ui/atoms/Colours';
import { useTranslation } from "react-i18next";
import { OutlineButton } from '@shared/ui/atoms/buttons/OutlineButton';
import { useDispatch } from "react-redux";
import {
  setActiveOfficeManagementPanel,
  setFocusedChildOffice
} from '@features/desks/store/editOfficeLayout.duck';
import { OfficeManagementPanelView } from "../../office-management-page-v2/data/OfficeManagement.model";

export function ManageAreaControl(props: Props) {
  const {areas, parentOffice, numberOfActiveDesks} = props;
  const [areaCapacity, setAreaCapacity] = useState(0);
  const {t} = useTranslation();
  const dispatch = useDispatch();

  useEffect(() => {
    getOfficeCapacity(parentOffice.id, moment())
      .then(resp => setAreaCapacity(Math.max(resp.capacity - numberOfActiveDesks, 0)));
  }, [parentOffice, numberOfActiveDesks]);

  const onClicked = () => {
    dispatch(setFocusedChildOffice(parentOffice));
    dispatch(setActiveOfficeManagementPanel(OfficeManagementPanelView.AreaManagement));
  }


  if (areas.length === 0) {
    return <ManageAreaControlContainer>
      <BodyRegular weight={600}>{t('settings.manage-area.create-area')}</BodyRegular>
      <BodySmall>{t('settings.manage-area.message-1')}</BodySmall>
      <BodySmall style={{marginBottom: 16}}>{t('settings.manage-area.message-2')}</BodySmall>
      <EditAreasButton>
        <OutlineButton click={onClicked}
                       text={"button.add-bookable-area"}
                       fullWidth={true} />
      </EditAreasButton>
    </ManageAreaControlContainer>
  } else {
    return <ManageAreaControlContainer>
      <BodyRegular weight={600}>{t('settings.manage-area.create-area')}</BodyRegular>
      <BodySmall>{t('settings.manage-area.message-1')}</BodySmall>
      <BodySmall style={{marginBottom: 16}}>{t('settings.manage-area.message-2')}</BodySmall>
      <BodyVerySmall colour={Colours.darkGrey}
                     style={{marginBottom: 4}}
                     weight={600}>{t('settings.manage-area.number-of-desks')}</BodyVerySmall>
      <Row style={{alignItems: 'center'}}>

        <SmallTextArea onChange={() => {}}
                       disabled={true}
                       dataTest={'area-capacity-field'}
                       value={`${areaCapacity}`} />

        <EditAreasButton>
          <OutlineButton click={onClicked}
                         text={"textinput.areas-names-and-avail"}
                         fullWidth={true} />
        </EditAreasButton>
      </Row>
    </ManageAreaControlContainer>
  }
}

interface Props {
  areas: OfficeEntity[];
  isEditable: boolean;
  parentOffice: OfficeEntity;
  numberOfActiveDesks: number;
}

const ManageAreaControlContainer = styled.div`
  margin-bottom: 48px;
`;

const EditAreasButton = styled.div`
  width: 250px;
  max-width: 250px;
  margin-right: 16px;
`;

const SmallTextArea = styled(TextField)<TextFieldProps>`
  max-width: 50px;
  margin: 0 16px 0 0;
  input {
    text-align: center;
  }
`;
